/*
 *
 * Package: `@dbh/google-map-theme`.
 *
 */const THEME_KEY_MAP="mapTheme";const modifyMapTheme=a=>{let{spacing:{sp3:b}}=a;return {[THEME_KEY_MAP]:{popup:{backgroundColor:"#F2F3F4",padding:b,width:"100%",maxHieght:"100%",height:"100%",mdMaxHeight:"100%"}}}};

export { THEME_KEY_MAP, modifyMapTheme as default };
